export default "__VITE_ASSET__BSm5rZBd__"